import { render, staticRenderFns } from "./WorkspaceFooter.vue?vue&type=template&id=2d21a516&scoped=true&"
import script from "./WorkspaceFooter.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21a516",
  null
  
)

export default component.exports